import React, { useContext, useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import companyIcon from "../../../../assets/Image/Company Icon .png";
import gasIcon from "../../../../assets/Image/GasIcon.png";
import useFormattingUtils from "../../../../context/useFormattingUtils";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { capitalizeFirstLetter } from "../../../../utils/helper/common";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import {
  CustomButton,
  RegularButton,
} from "../../../common/ReusableComponent/CustomButton";
import { ReusableInput, SelectInput } from "../../../common/ReusableComponent/ReusableInput";
import ReusableTable from "../../../common/ReusableComponent/reusableTable/ReusableTable";
import useSwal from '../../../common/ReusableComponent/useSwal';
import { useToastHandler } from '../../../common/ToastHandler';
import ReusableModal from "../ManageSettings/ReusableModal";
import "./Gas.css";

function GasSettings() {
  let { user } = useContext(AuthContext);
  const storeId = user.store;
  const [gasTypeTitle, setGasTypeTitle] = useState("");
  const [costPerGallon, setCostPerGallon] = useState("");
  const [gasTypeData, setGasTypeData] = useState([]);
  const [gasCompany, setGasCompany] = useState("");
  const [companyContact, setCompanyContact] = useState("");
  const [companyEmail, setcompanyEmail] = useState("");
  const [companyData, setCompanyData] = useState([]);
  const [gasName, setGasName] = useState("");
  const [gasCommission, setGasCommission] = useState("");
  const [commissionDate, setCommissionDate] = useState("");
  const [commissionData, setCommissionData] = useState([]);
  const { Post, Put, Delete, Patch, Get , getAPI , GetPaginatedData} = useApi();
  const [showGasTypeModal, setShowGasTypeModal] = useState(false);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [showCommissionModal, setShowCommissionModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const{handleToast} = useToastHandler()
  const { formatDate } = useFormattingUtils();
  const {confirmDelete} = useSwal()
const [currentGasTypeTableData, setCurrentGasTypeTableData] = useState([]);
const [currentCompanyTableData, setCurrentCompanyTableData] = useState([]);
const [currentCommissionTableData, setCurrentCommissionTableData] = useState([]);

  const [gasTypeRefreshTrigger, setGasTypeRefreshTrigger] = useState(0);
  const [companyRefreshTrigger, setCompanyRefreshTrigger] = useState(0);
  const [commissionRefreshTrigger, setCommissionRefreshTrigger] = useState(0);

  const [errors, setErrors] = useState({
    gasType: {},
    company: {},
    commission: {}
  });

  const [selectedGasType, setSelectedGasType] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedCommission, setSelectedCommission] = useState(null);

  const handleShowGasType = () => setShowGasTypeModal(true);
  const handleCloseGasType = () => {
    setGasTypeTitle("");
    setCostPerGallon("");
    setSelectedGasType(null);
    setShowGasTypeModal(false);
    setErrors(prev => ({ ...prev, gasType: {} }));
  };
  const handleShowCompany = () => setShowCompanyModal(true);
  const handleCloseCompany = () => {
    setGasCompany("");
    setCompanyContact("");
    setcompanyEmail("");
    setSelectedCompany(null);
    setShowCompanyModal(false);
    setErrors(prev => ({ ...prev, company: {} }));
  };
  const handleShowCommission = () => setShowCommissionModal(true);
  const handleCloseCommission = () => {
    setGasName("");
    setGasCommission("");
    setCommissionDate("");
    setSelectedCommission(null);
    setShowCommissionModal(false);
    setErrors(prev => ({ ...prev, commission: {} }));
  };

const fetchGasTypeData = async ({ page = 1, searchTerm = "" }) => {
  return fetchDatas({
    apiKey: "gasTypeData",
    setStateCallback: setCurrentGasTypeTableData,
    page,
    searchTerm,
  });
};

const fetchCompanyData = async ({ page = 1, searchTerm = "" }) => {
  return fetchDatas({
    apiKey: "gasCompanyData",
    setStateCallback: setCurrentCompanyTableData,
    page,
    searchTerm,
  });
};
const fetchDatas = async ({
  apiKey,
  setStateCallback,
  page = 1,
  searchTerm = "",
  sort = "",
  order = "",
} = {}) => {
  try {
    setLoading(true);

    const response = await GetPaginatedData(apiKey, {
      page,
      search: searchTerm,
      queryParams: {
        ...(sort && { sort }),
        ...(order && { order }),
      },
    });

    const results = response?.data || [];
    const count = response?.totalCount || 0;
    const totalPages = Math.ceil(count / 10);

    if (setStateCallback) {
      setStateCallback(results);
    }

    return { data: results, totalPages };
  } catch (error) {
    console.error(`Error fetching '${apiKey}' data:`, error);

    return { data: [], totalPages: 1 };
  } finally {
    setLoading(false);
  }
};

const fetchCommissionData = async ({ page = "", searchTerm = "" }) => {
  const { data, totalPages } = await fetchDatas({
    apiKey: "gasCommissionData",
    page,
    searchTerm,
  });

  const transformed = data.map((item) => ({
    ...item,
    date_from: item.date_from ? formatDate(item.date_from) : "N/A",
  }));

  setCurrentCommissionTableData(transformed);

  return { data: transformed, totalPages };
};

useEffect(() => {
  fetchInitialData();
}, []);

const fetchInitialData = async () => {
  try {
    const response = await Get(getAPI("gasTypeData"));
    setGasTypeData(response.results || []);
  } catch (error) {
    console.error("Error fetching initial gas type data:", error);
  }
};


  const validateGasType = () => {
    const newErrors = {};

    if (!gasTypeTitle.trim()) {
      newErrors.gasTypeTitle = "Gas type title is required";
    }

    if (!costPerGallon) {
      newErrors.costPerGallon = "Cost per gallon is required";
    } else if (isNaN(costPerGallon) || parseFloat(costPerGallon) <= 0) {
      newErrors.costPerGallon = "Please enter a valid cost per gallon";
    }

    setErrors(prev => ({ ...prev, gasType: newErrors }));
    return Object.keys(newErrors).length === 0;
  };

  const validateCompany = () => {
    const newErrors = {};

    if (!gasCompany.trim()) {
      newErrors.name = "Company name is required";
    }

    if (!companyContact) {
      newErrors.contact = "Contact number is required";
    } else if (!/^\d{10,12}$/.test(companyContact)) {
      newErrors.contact = "Please enter a valid contact number";
    }

    if (!companyEmail.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(companyEmail)) {
      newErrors.email = "Please enter a valid email address";
    } else if (/[^a-zA-Z0-9@._-]/.test(companyEmail)) {
      newErrors.email = "Email contains invalid special characters";
    }

    setErrors(prev => ({ ...prev, company: newErrors }));
    return Object.keys(newErrors).length === 0;
  };

  const validateCommission = () => {
    const newErrors = {};

    if (!gasName) {
      newErrors.gasType = "Please select a gas type";
    }

    if (!gasCommission) {
      newErrors.commission = "Commission percentage is required";
    } else if (isNaN(gasCommission) || parseFloat(gasCommission) < 0 || parseFloat(gasCommission) > 100) {
      newErrors.commission = "Commission must be between 0 and 100";
    }

    if (!commissionDate) {
      newErrors.date = "Date is required";
    }

    setErrors(prev => ({ ...prev, commission: newErrors }));
    return Object.keys(newErrors).length === 0;
  };

const handleEditGasType = (gasTypeIdOrObject) => {
  let gasTypeObject;
  if (typeof gasTypeIdOrObject === 'string') {

    gasTypeObject = currentGasTypeTableData.find(item => item.id === gasTypeIdOrObject) ||
                    gasTypeData.find(item => item.id === gasTypeIdOrObject);
  } else if (gasTypeIdOrObject && typeof gasTypeIdOrObject === 'object') {
    gasTypeObject = gasTypeIdOrObject;
  }

  if (!gasTypeObject || !gasTypeObject.id) {
    console.error("Invalid gas type object or missing ID:", gasTypeObject);
    handleToast({
      type: "ERROR",
      message: "Cannot edit: Invalid item selected"
    });
    return;
  }

  setSelectedGasType({ ...gasTypeObject });
  setGasTypeTitle(gasTypeObject.gas_type_title || "");
  setCostPerGallon(gasTypeObject.cost_per_gallon || "");
  handleShowGasType();
};

const handleEditCompany = (companyIdOrObject) => {
  let companyObject;
  if (typeof companyIdOrObject === 'string') {
    companyObject = currentCompanyTableData.find(item => item.id === companyIdOrObject) ||
                    companyData.find(item => item.id === companyIdOrObject);
  } else if (companyIdOrObject && typeof companyIdOrObject === 'object') {
    companyObject = companyIdOrObject;
  }

  if (!companyObject || !companyObject.id) {
    console.error("Invalid company object or missing ID:", companyObject);
    handleToast({
      type: "ERROR",
      message: "Cannot edit: Invalid item selected"
    });
    return;
  }

  setSelectedCompany({ ...companyObject });
  setGasCompany(companyObject.name || "");
  setCompanyContact(companyObject.contact_no || "");
  setcompanyEmail(companyObject.email || "");
  handleShowCompany();
};
const handleEditCommission = (commissionIdOrObject) => {
  let commissionObject;

  if (typeof commissionIdOrObject === 'string') {

    commissionObject = currentCommissionTableData.find(item => item.id === commissionIdOrObject) ||
     commissionData.find(item => item.id === commissionIdOrObject);
  } else if (commissionIdOrObject && typeof commissionIdOrObject === 'object') {
    commissionObject = commissionIdOrObject;
  }

  if (!commissionObject || !commissionObject.id) {
    console.error("Invalid commission object or missing ID:", commissionObject);
    handleToast({
      type: "ERROR",
      message: "Cannot edit: Invalid item selected"
    });
    return;
  }

  setSelectedCommission({ ...commissionObject });
  setGasName(commissionObject.gas_type || commissionObject.gas_type_id || "");
  setGasCommission(commissionObject.commission_percentage || "");

  let dateValue = commissionObject.date_from;
  if (dateValue && dateValue !== "N/A") {

    if (dateValue.includes('/')) {
      const parts = dateValue.split('/');
      dateValue = `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
    }
  }
  setCommissionDate(dateValue || "");
  handleShowCommission();
};

  const handleGasTypeChange = (e) => {
    const { name, value } = e.target;

    if (name === "gas_type_title") {
      setGasTypeTitle(capitalizeFirstLetter(value));
      if (value.trim()) {
        setErrors(prev => ({
          ...prev,
          gasType: {
            ...prev.gasType,
            gasTypeTitle: ""
          }
        }));
      }
    }

    if (name === "cost_per_gallon") {
      const validCostPerGallon = /^\d{1,8}(\.\d{0,2})?$/;

      if (validCostPerGallon.test(value)) {
        setCostPerGallon(value);
        setErrors(prev => ({
          ...prev,
          gasType: {
            ...prev.gasType,
            costPerGallon: ""
          }
        }));
      }
    }
  };

  const handleCompanyChange = (e) => {
    const { name, value } = e.target;

    if (name === "name") {
      setGasCompany(capitalizeFirstLetter(value));
      if (value.trim()) {
        setErrors(prev => ({
          ...prev,
          company: {
            ...prev.company,
            name: ""
          }
        }));
      }
    }

    if (name === "contact_no") {
      const cleanedValue = value.replace(/\D/g, "");

      if (cleanedValue.length <= 12) {
        setCompanyContact(cleanedValue);
        if (cleanedValue.length >= 10) {
          setErrors(prev => ({
            ...prev,
            company: {
              ...prev.company,
              contact: ""
            }
          }));
        }
      }
    }

    if (name === "email") {
      // Only allow valid email characters
      const filteredValue = value.replace(/[^a-zA-Z0-9@._-]/g, "");
      setcompanyEmail(filteredValue);
      if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(filteredValue)) {
        setErrors(prev => ({
          ...prev,
          company: {
            ...prev.company,
            email: ""
          }
        }));
      } else if (/[^a-zA-Z0-9@._-]/.test(value)) {
        setErrors(prev => ({
          ...prev,
          company: {
            ...prev.company,
            email: "Email contains invalid special characters"
          }
        }));
      }
    }
  };

  const handleCommissionChange = (e) => {
    const { name, value } = e.target;

    if (name === "gas_type") {
      setGasName(value);
      if (value) {
        setErrors(prev => ({
          ...prev,
          commission: {
            ...prev.commission,
            gasType: ""
          }
        }));
      }
    }

    if (name === "commission_percentage") {
      let commissionValue = parseFloat(value);

      if (commissionValue > 100) {
        commissionValue = 100;
        handleToast({
          type: "INFO",
          message: "Commission percentage cannot exceed 100%. It has been set to 100%."
        });
      } else if (commissionValue < 0) {
        commissionValue = 0;
        handleToast({
          type: "ERROR",
          message: "Commission percentage cannot be negative. It has been set to 0%."
        });
      }

      setGasCommission(commissionValue);
      if (!isNaN(commissionValue) && commissionValue >= 0 && commissionValue <= 100) {
        setErrors(prev => ({
          ...prev,
          commission: {
            ...prev.commission,
            commission: ""
          }
        }));
      }
    }

    if (name === "date_from") {
      setCommissionDate(value);
      if (value) {
        setErrors(prev => ({
          ...prev,
          commission: {
            ...prev.commission,
            date: ""
          }
        }));
      }
    }
  };

  const handleGasTypeSubmit = async (e) => {
    e.preventDefault();

    if (!validateGasType()) {
      return;
    }

    const gasData = {
      gas_type_title: gasTypeTitle,
      cost_per_gallon: costPerGallon,
      is_enable: false,
      store: storeId,
    };

    try {
      if (selectedGasType && selectedGasType.id) {
        await Put("gasTypeData", selectedGasType.id, gasData);

        setGasTypeData(prev => 
          prev.map(item => 
            item.id === selectedGasType.id ? { ...item, ...gasData, id: selectedGasType.id } : item
          )
        );

        setGasTypeRefreshTrigger(prev => prev + 1);

        handleToast({
          type: "SUCCESS",
          message: "Gas type data updated successfully!"
        });
      } else {
        const response = await Post("gasTypeData", gasData);

        setGasTypeData(prev => [response.data, ...prev]);

        setGasTypeRefreshTrigger(prev => prev + 1);

        handleToast({
          type: "SUCCESS",
          message: "Gas type data added successfully!"
        });
      }
    } catch (error) {
      console.error("Error with gas type data:", error);
      handleToast({
        type: "ERROR",
        message: `${error.response?.data}`
      });
    } finally {
      handleCloseGasType();
    }
  };

  const handleCompanySubmit = async (e) => {
    e.preventDefault();

    if (!validateCompany()) {
      return;
    }

    const gasCompanyData = {
      store: storeId,
      name: gasCompany,
      contact_no: companyContact,
      email: companyEmail,
    };

    try {
      if (selectedCompany && selectedCompany.id) {
        await Put("gasCompanyData", selectedCompany.id, gasCompanyData);

        setCompanyData(prev => 
          prev.map(item => 
            item.id === selectedCompany.id ? { ...item, ...gasCompanyData, id: selectedCompany.id } : item
          )
        );

        setCompanyRefreshTrigger(prev => prev + 1);

        handleToast({
          type: "SUCCESS",
          message: "Company data updated successfully!"
        });
      } else {
        const response = await Post("gasCompanyData", gasCompanyData);

        setCompanyData(prev => [response.data, ...prev]);

        setCompanyRefreshTrigger(prev => prev + 1);

        handleToast({
          type: "SUCCESS",
          message: "Company data added successfully!"
        });
      }
    } catch (error) {
      console.error("Error with company data:", error);
      
      let errorMessage = "Error saving company data.";
      
      if (error.response?.data?.non_field_errors) {
        errorMessage = error.response.data.non_field_errors[0];
      } else if (error.response?.data) {
        errorMessage = typeof error.response.data === 'string' 
          ? error.response.data 
          : JSON.stringify(error.response.data);
      }
      
      handleToast({
        type: "ERROR",
        message: errorMessage
      });
    } finally {
      handleCloseCompany();
    }
  };

  const handleCommissionSubmit = async (e) => {
    e.preventDefault();

    if (!validateCommission()) {
      return;
    }

    const gasCommissionData = {
      gas_type: gasName,
      commission_percentage: gasCommission,
      date_from: commissionDate,
      store: storeId,
    };

    try {
      if (selectedCommission && selectedCommission.id) {
        await Put("gasCommissionData", selectedCommission.id, gasCommissionData);

        setCommissionData(prev => 
          prev.map(item => 
            item.id === selectedCommission.id ? { ...item, ...gasCommissionData, id: selectedCommission.id } : item
          )
        );

        setCommissionRefreshTrigger(prev => prev + 1);

        handleToast({
          type: "SUCCESS",
          message: "Commission data updated successfully!"
        });
      } else {
        const response = await Post("gasCommissionData", gasCommissionData);

        setCommissionData(prev => [response.data, ...prev]);

        setCommissionRefreshTrigger(prev => prev + 1);

        handleToast({
          type: "SUCCESS",
          message: "Commission data added successfully!"
        });
      }
    } catch (error) {
      console.error("Error with commission data:", error);
      
      let errorMessage = "Error saving commission data.";
      
      if (error.response?.data) {
        if (error.response.data.date_from) {
          errorMessage = error.response.data.date_from[0];
        } else if (error.response.data.non_field_errors) {
          errorMessage = error.response.data.non_field_errors[0];
        } else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data;
        } else {
          errorMessage = JSON.stringify(error.response.data);
        }
      }
      
      handleToast({
        type: "ERROR",
        message: errorMessage
      });
    } finally {
      handleCloseCommission();
    }
  };

  const handleDeleteGasType = async (idOrObject) => {
    const id = typeof idOrObject === 'string' ? idOrObject : idOrObject?.id;

    if (!id) {
      handleToast({
        type: "ERROR",
        message: "Cannot delete: Invalid item selected"
      });
      return;
    }

    try {
      const result = await confirmDelete();
      if (!result.isConfirmed) return;

      await Delete("gasTypeData", id);

      setGasTypeData(prev => prev.filter(item => item.id !== id));

      setGasTypeRefreshTrigger(prev => prev + 1);

      handleToast({
        type: "SUCCESS",
        message: "Gas type deleted successfully"
      });
    } catch (error) {
      console.error("Error deleting gas type data:", error);
      handleToast({
        type: "ERROR",
        message: "Error deleting gas type"
      });
    }
  };

  const handleDeleteCompanyData = async (idOrObject) => {
    const id = typeof idOrObject === 'string' ? idOrObject : idOrObject?.id;

    if (!id) {
      handleToast({
        type: "ERROR",
        message: "Cannot delete: Invalid item selected"
      });
      return;
    }

    try {
      const result = await confirmDelete();
      if (!result.isConfirmed) return;

      await Delete("gasCompanyData", id);

      setCompanyData(prev => prev.filter(item => item.id !== id));

      setCompanyRefreshTrigger(prev => prev + 1);

      handleToast({
        type: "SUCCESS",
        message: "Gas Company deleted successfully"
      });
    } catch (error) {
      console.error("Error deleting gas company:", error);
      handleToast({
        type: "ERROR",
        message: "Error deleting gas company."
      });
    }
  };

  const handleDeleteGasCommision = async (idOrObject) => {
    const id = typeof idOrObject === 'string' ? idOrObject : idOrObject?.id;

    if (!id) {
      handleToast({
        type: "ERROR",
        message: "Cannot delete: Invalid item selected"
      });
      return;
    }

    try {
      const result = await confirmDelete();
      if (!result.isConfirmed) return;

      await Delete("gasCommissionData", id);

      setCommissionData(prev => prev.filter(item => item.id !== id));

      setCommissionRefreshTrigger(prev => prev + 1);

      handleToast({
        type: "SUCCESS",
        message: "Gas Commission deleted successfully"
      });
    } catch (error) {
      console.error("Error deleting gas commission:", error);
      handleToast({
        type: "ERROR",
        message: "Error deleting gas commission"
      });
    }
  };

  const handleEnableDisable = (id, isActive) => {
    const updatedStatus = !isActive;

    Patch("gasTypeData", id, { is_enable: updatedStatus })
      .then(() => {

        setGasTypeRefreshTrigger(prev => prev + 1);

        handleToast({
          type: "SUCCESS",
          message: `Gas Type ${updatedStatus ? "Enabled" : "Disabled"} successfully!`
        });
      })
      .catch((error) => {
        console.error("Error updating status:", error);
        handleToast({
          type: "ERROR",
          message: "Failed to update status."
        });
      });
  };

  const gasTypeColumns = [
    { header: "Gas Type Title", field: "gas_type_title" },
    { header: "Cost Per Gallon", field: "cost_per_gallon" },
    { header: "Is Blended", field: "is_blended" },
    { header: "Blended", field: "is_blended" },
  ];

  const companyColumns = [
    { header: "Company Name", field: "name" },
    { header: "Contact No", field: "contact_no" },
    { header: "Email", field: "email" },
  ];

  const commissionColumns = [
    { header: "Gas Type", field: "gas_type_title" },
    { header: "Commission Percentage", field: "commission_percentage" },
    { header: "Date From", field: "date_from" },
  ];

  return (
    <>
      <ToastContainer />
      <div className="responsive-box">
        <div className="header-row mb-4">
          <div className="setting-title">Gas Types</div>
          <div
            className="btn-position"
            style={{ display: "flex", gap: "10px" }}
          >
            <CustomButton
              text="Add Gas Type"
              icon={gasIcon}
              onClick={handleShowGasType}
            />
          </div>
        </div>

        <ReusableModal
          show={showGasTypeModal}
          handleClose={handleCloseGasType}
          title={selectedGasType ? "Edit Gas Type" : "Add Gas Type"}
          width="700px"
          height="auto"
        >
          <form onSubmit={handleGasTypeSubmit}>
            <div
              className="d-flex align-items-center mt-3 mx-3"
              style={{ gap: "40px" }}
            >
              <ReusableInput
                type="text"
                name="gas_type_title"
                label="Gas Type Title"
                placeholder=""
                value={gasTypeTitle}
                onChange={handleGasTypeChange}
                error={errors.gasType.gasTypeTitle}
              />
              <ReusableInput
                type="number"
                name="cost_per_gallon"
                label="Cost Per Gallon"
                placeholder=""
                value={costPerGallon}
                onChange={handleGasTypeChange}
                error={errors.gasType.costPerGallon}
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end",marginTop:"20px" }}>
              <RegularButton
                type="submit"
                text={selectedGasType ? "Update" : "Submit"}
              />
            </div>
          </form>
        </ReusableModal>

        {}
        <ReusableTable
        fetchData={fetchGasTypeData}
          columns={gasTypeColumns}
          showEnableDisable={true}
          onEnableDisable={handleEnableDisable} 

          showAction={true}
          onEdit={handleEditGasType}
          onDelete={handleDeleteGasType}

          loading={loading}
          key={gasTypeRefreshTrigger} 
        />
      </div>

      <div className="responsive-box">
        <div className="header-row mt-4 mb-4">
          <div className="setting-title">Gas Companies (For House Charges)</div>
          <div
            className="btn-position"
            style={{ display: "flex", gap: "10px" }}
          >
            <CustomButton
              text="Add Company"
              icon={companyIcon}
              onClick={handleShowCompany}
            />
          </div>
        </div>

        <ReusableModal
          show={showCompanyModal}
          handleClose={handleCloseCompany}
          title={selectedCompany ? "Edit Gas Company" : "Add Gas Company"}
          width="850px"
          height="auto"
        >
          <form onSubmit={handleCompanySubmit}>
            <div
              className="d-flex align-items-center mt-3 mx-3"
              style={{ gap: "40px" }}
            >
              <ReusableInput
                type="text"
                name="name"
                label="Company Name"
                placeholder=""
                value={gasCompany}
                onChange={handleCompanyChange}
                error={errors.company.name}
              />
              <ReusableInput
                type="number"
                name="contact_no"
                label="Company Contact No"
                placeholder=""
                value={companyContact}
                onChange={handleCompanyChange}
                error={errors.company.contact}
              />
              <ReusableInput
                type="email"
                name="email"
                label="Email"
                placeholder=""
                value={companyEmail}
                onChange={handleCompanyChange}
                error={errors.company.email}
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end",marginTop:"20px"  }}>
              <RegularButton
                type="submit"
                text={selectedCompany ? "Update" : "Submit"}
              />
            </div>
          </form>
        </ReusableModal>

        {}
        <ReusableTable
          fetchData={fetchCompanyData}
          columns={companyColumns}
          showAction={true}
          showExport={false}
          showFilter={false}
          enablePagination={true}
          onEdit={handleEditCompany}
          onDelete={handleDeleteCompanyData}
          // rowsPerPage={10}
          showFooter={true}
          loading={loading}
          key={companyRefreshTrigger} 
        />
      </div>

      <div className="responsive-box">
        <div className="header-row mt-4 mb-4">
          <div className="setting-title">Gas Type Commision</div>
          <div
            className="btn-position"
            style={{ display: "flex", gap: "10px" }}
          >
            <CustomButton
              text="Add Gas Commissions"
              icon={gasIcon}
              onClick={handleShowCommission}
            />
          </div>
        </div>

        <ReusableModal
          show={showCommissionModal}
          handleClose={handleCloseCommission}
          title={
            selectedCommission ? "Edit Gas Commission" : "Add Gas Commission"
          }
          width="900px"
          height="auto"
        >
          <form onSubmit={handleCommissionSubmit}>
            <div
              className="d-flex align-items-center mt-3 mx-3"
              style={{ gap: "40px" }}
            >
              <div className="mt-2">
                <SelectInput
                  name="gas_type"
                  value={gasName}
                  onChange={handleCommissionChange}
                  label="Select Gas Type"
                  options={gasTypeData?.map(gas => ({
                    id: gas.id,
                    name: gas.gas_type_title
                  })) || []}
                  error={errors.commission.gasType}
                  style={{ width: "230px" }}
                />
              </div>
              <div className="mt-2">
                <ReusableInput
                  type="number"
                  name="commission_percentage"
                  label="Commission Percentage"
                  placeholder=""
                  value={gasCommission}
                  onChange={handleCommissionChange}
                  error={errors.commission.commission}
                />
              </div>
              <div className="mt-2">
                <ReusableInput
                  type="date"
                  name="date_from"
                  label="Date From"
                  placeholder=""
                  value={commissionDate}
                  onChange={handleCommissionChange}
                  error={errors.commission.date}
                />
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
              <RegularButton
                type="submit"
                text={selectedCommission ? "Update" : "Submit"}
              />
            </div>
          </form>
        </ReusableModal>

        {}
        <ReusableTable
          fetchData={fetchCommissionData}
          columns={commissionColumns}
          showAction={true}
          showExport={false}
          showFilter={false}
          enablePagination={true}
          onEdit={handleEditCommission}
          onDelete={handleDeleteGasCommision}
 
          showFooter={true}
          loading={loading}
          key={commissionRefreshTrigger} 
        />
      </div>
    </>
  );
}

export default GasSettings;